import script from "./ClickUnit.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClickUnit.vue?vue&type=script&lang=ts&setup=true"

import "./ClickUnit.vue?vue&type=style&index=0&id=3afe65e3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3afe65e3"]])

export default __exports__